module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAYAAADFniADAAAA6klEQVRYhe2YwQ2EIBBFKcFSLIESLMFO1g60gy1FOlg70E7eHoQNenEwqxAzL+FC4vDCGJ18YzxADbyA8WBZIwToBfVGf269f7hFziQUsgk1A218QykMQqkKWE6I1Qbooo0OqKTt+QdefuNgABdt3Cq0Ewu4jVQOoUhMpVRKpYqQssCE8Et9odTgPWxOD+WhAA0wUwYz0OynhBJw4abODGNXsABN7rdHeSCs/74P0Gf26L2HLXZKUCmVUqnsUhSUJcSJx+tuMS/0jhy6q/OpObE2hESP0pK8qEjN2kp3sGxCawZBPefP/WWeX+RP9yFsu+pNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon_4.png
// module id = YQPG
// module chunks = 1